import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  imageUrl: string;
  handleBannerClick: () => void;
}
export const DescriptionTopBanner: React.FC<React.PropsWithChildren<Props>> = ({ imageUrl, handleBannerClick }) => {
  return (
    <Container>
      <img src={imageUrl} onClick={handleBannerClick} alt='배너 이미지' />
    </Container>
  );
};

const Container = styled.div`
  padding: 16px;
  border-bottom: 8px solid ${vars.v3Color.gray100};

  img {
    border-radius: 8px;
  }
`;
